import { Button, DialogActions, DialogContent } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
//import CloseIcon from '@material-ui/icons/Close';
import React, { useEffect, useState } from "react";

const MODAL_TIMEOUT = 60 * 3;

export function SessionExpiredDialog(props) {

  //let previosLocationKey;

  //const location = useLocation();

  const [open, setOpen] = useState(false);

  const [counter, setCounter] = useState(MODAL_TIMEOUT);

  const {
    // onAppLogout,
    onRefreshToken,
    onGoLoginPage
  } = props;

  const handleLogout = () => {
    //onAppLogout()
    onGoLoginPage();
  }

  const handleStaySignedIn = () => {
    onRefreshToken();
    setOpen(false);
  }

  useEffect(() => {
    let interval = null;
    if (props.sessionExpired || false) {
      var timer = MODAL_TIMEOUT, minutes, seconds;
      setOpen(true);
      interval = setInterval(function () {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        setCounter(minutes + ":" + seconds);

        if (--timer < 0) {
          handleLogout();
        }
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [props.sessionExpired]);

  return (
    <div>
      <Dialog open={open}>
        <DialogTitle sx={{ m: 0, p: 2 }} tabIndex={0}>Need More Time?</DialogTitle>
        {/* <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton> */}
        <DialogContent tabIndex={0} dividers>
          Your session is about to expire. You will be automatically signed out in
          <p><h3>{counter}</h3></p>
          <p>To continue your session, select <b>Stay Signed In</b></p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleStaySignedIn} variant="contained" color="primary">
            Stay Signed In
          </Button>
          <Button onClick={handleLogout} variant="outlined">
            Sign Out
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default SessionExpiredDialog;